import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import urlUtils from '@services/urlUtils'
import Pagination from '@components/Table/Pagination'
import TableContent from '@components/Table/TableContent'
import PaginatedTableHeader from '@components/Table/PaginatedTableHeader'
import * as Utils from '@services/utils'
import 'bootstrap/dist/css/bootstrap.min.css'
import i18n from '@localization/i18n'

export default ({
    title,
    columns,
    filters,
    collection,
    loadAction,
    useFunction,
    items,
    ExpandedRowComponent,
    onExpandRow,
    activeFilter,
    hideTableHeader,
    hidePageSize,
    withDateFilters,
    loadTrigger,
    secondLoadTrigger,
    resetPage,
    totalItems,
}) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const queryParams = urlUtils.getQueryParams()
    const [page, setPage] = useState(queryParams.page || 1)
    const [originalPage, setOriginalPage] = useState(
        queryParams.originalPage || null
    )
    const [pageSize, setPageSize] = useState(queryParams.pageSize || 10)
    const [selectedFilters, setSelectedFilters] = useState(
        activeFilter
            ? Object.assign({}, activeFilter)
            : queryParams.filter
            ? JSON.parse(queryParams.filter)
            : {}
    )
    useEffect(() => {
        if (secondLoadTrigger) {
            setPage(1)
            loadTableData()
        }
    }, [secondLoadTrigger])
    useEffect(() => {
        if (
            loadTrigger === 'searchByTerm' ||
            loadTrigger === 'searchByTermTranslated' ||
            loadTrigger === 'searchByMultiple'
        ) {
            setPage(1)
            loadTableData()
        }
    }, [loadTrigger])

    useEffect(() => {
        if (activeFilter) {
            let filterName = Object.keys(activeFilter)[0]
            updateSoloActiveFilter(filterName, activeFilter[filterName])
        } else {
            if (queryParams.filter) {
                setSelectedFilters(JSON.parse(queryParams.filter))
            } else {
                setSelectedFilters({})
            }
        }
    }, [location.state])

    const [orderBy, setOrderBy] = useState(
        queryParams.orderBy ? JSON.parse(queryParams.orderBy) : {}
    )
    const [search, setSearch] = useState(queryParams.search || '')
    const [searchForApi, setSearchForApi] = useState(queryParams.search || '')
    const data = items ? items : useFunction && useFunction()

    const [fromDate, setFromDate] = useState(
        queryParams.from_date || moment().subtract(7, 'd').toISOString()
    )
    const [toDate, setToDate] = useState(
        queryParams.to_date || new Date().toISOString()
    )

    const updateSoloActiveFilter = (name, selected) => {
        const newFilter = {}
        if (selected && selected.length > 0) {
            newFilter[name] = selected.map((sel) => sel)
        } else {
            if (newFilter[name]) {
                delete newFilter[name]
            }
        }
        changeSelectedFilters(newFilter)
    }

    const loadTableData = () => {
        if (useFunction) {
            dispatch(
                loadAction(
                    page,
                    pageSize,
                    orderBy,
                    searchForApi,
                    getFiltersObj(),
                    Utils.dateForServer(fromDate),
                    Utils.dateForServer(toDate)
                )
            )
        }
    }

    useEffect(() => {
        if (withDateFilters) {
            urlUtils.setQueryParams({ from_date: fromDate })
            urlUtils.setQueryParams({ to_date: toDate })
            console.log(urlUtils)
        }
    }, [withDateFilters])

    useEffect(() => {
        if (
            queryParams.page != page &&
            !(page == 1 && !queryParams.page) &&
            page !== 0
        ) {
            urlUtils.setQueryParams({ page })
        }
        // loadTableData()
    }, [page])

    useEffect(() => {
        loadTableData()
    }, [
        page,
        pageSize,
        selectedFilters,
        searchForApi,
        orderBy,
        fromDate,
        toDate,
    ])

    useEffect(() => {
        if (page === 0 || queryParams.page === 0) {
            setPage(1)
            // loadTableData()
            urlUtils.setQueryParams({ page: 1 })
        }
    }, [page])

    useEffect(() => {
        if (page === 1) {
            if (originalPage && originalPage !== 0) {
                setPage(originalPage)
                setOriginalPage(null)
                urlUtils.setQueryParams({ originalPage: null })
            }
            // console.log('HERE 0')
            // loadTableData()
        } else {
            // setPage(1)
            // loadTableData()
        }
    }, [pageSize, selectedFilters, searchForApi, orderBy, fromDate, toDate])

    const changePageSize = (ps) => {
        setPageSize(ps)
        urlUtils.setQueryParams({ pageSize: ps })
    }

    const changeSelectedFilters = (sf) => {
        setSelectedFilters(sf)
        urlUtils.setQueryParams({ filter: JSON.stringify(sf) })
    }

    const changeSearch = (s) => {
        setSearch(s)
        urlUtils.setQueryParams({ search: s })
        Utils.onControlledChange(s, 0, (text) => {
            setSearchForApi(s)
        })
    }

    const changeOrderBy = (newObj) => {
        setOrderBy(newObj)
        urlUtils.setQueryParams({ orderBy: JSON.stringify(newObj) })
    }

    const getFiltersObj = () => {
        let newObj = {}
        Object.keys(selectedFilters).forEach((name) => {
            newObj[name] = selectedFilters[name].map((f) => f.value)
        })
        return newObj
    }

    const exportData = () => {}

    const changeFromDate = (date) => {
        setFromDate(date)
        urlUtils.setQueryParams({ from_date: date })
    }
    const changeToDate = (date) => {
        setToDate(date)
        urlUtils.setQueryParams({ to_date: date })
    }

    return (
        <Wrapper>
            {!hideTableHeader && (
                <PaginatedTableHeader
                    title={title}
                    filters={filters}
                    searchPlaceholder={i18n.t('table.search') + ' ' + title}
                    setSelectedFilters={changeSelectedFilters}
                    onExportData={exportData}
                    onChangeSearch={changeSearch}
                    selectedFilters={selectedFilters}
                    page={page}
                    search={search}
                    collection={collection}
                    data={(data && data.data) || data}
                    withDateFilters={withDateFilters}
                    fromDate={fromDate}
                    toDate={toDate}
                    changeFromDate={changeFromDate}
                    changeToDate={changeToDate}
                />
            )}
            <TableContent
                data={(data && data.data) || data}
                columns={columns}
                ExpandedRowComponent={ExpandedRowComponent}
                onExpandRow={onExpandRow}
                orderBy={orderBy}
                changeOrderBy={changeOrderBy}
                page={page}
            />
            <Pagination
                page={page}
                pageSize={pageSize}
                totalItems={totalItems || (data && data.total)}
                onChangePage={setPage}
                onChangePageSize={changePageSize}
                hidePageSize={hidePageSize}
            />
        </Wrapper>
    )
}
const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`
